import { constVarianteKeyErstanforderung, constVarianteKeyAenderung, constVarianteKeyAbmeldung, constFTypeTextField, constFTypeDropdown } from "../../../../common/CommonConstants";
import { IFormField, IGenericOption, IVariant } from "../../../../common/CommonTypes";

import * as commonCode from "../../../../common/components/request/RequestCommonCode";

// ============ ListNames =============
export const constLNVoltages = "Spannungsebenen";

export const constLageMaxWidthChar = 128;

export const apiEndpointSubmit =
  "https://medienantraege-backend-v2.azurewebsites.net/api/GetAntragNetzanschlussStromnetz?code=xp5tihHpfE8d6H16aTuVjbLA1MJOumikdP6FD9dgtgy8AzFucvvCBA==";
  // "https://medienantraege-backend.azurewebsites.net/api/GetAntragAnderungNetzanschlussStromnetz?code=a0YksX7Dg26VnxTeaS6d8ZDgV/2oKg4n2kQDXGuQ3lENYzIjQZeW8A==";
  // "https://inf-medienantragev2.azurewebsites.net/api/GetAntragAnderungNetzanschlussStromnetz?code=u/h62/iWcQq5OYu7X51vIRdhPdK6RMAlhWoqJFI02SV/MrHyLdhsMA==";
  //   " http://localhost:7071/api/GetAntragAnderungNetzanschlussStromnetz";
  // "http://localhost:7071/api/GetAntragNetzanschlussStromnetz?code=xp5tihHpfE8d6H16aTuVjbLA1MJOumikdP6FD9dgtgy8AzFucvvCBA==";

export const AntragstellerAnschlussnehmerStyle = {
  root: { 
    display: "flex", 
    marginTop: "18px" 
  },
};    

export const LeistungsanderungOPSConsts: IGenericOption[] = [
  { key: "Erhöhung", text: "Erhöhung " },
  { key: "Minderung", text: "Minderung" },
];

export const AntragstellerAnschlussnehmerOPSConsts: IGenericOption[] = [
  { key: "ja", text: "ja" },
  { key: "nein", text: "nein" },
];

export const VariantenSN: IVariant[] = [
  { Key: constVarianteKeyErstanforderung, RadioButtonLabel: constVarianteKeyErstanforderung, AbschnittTitel: constVarianteKeyErstanforderung },
  { Key: constVarianteKeyAenderung, RadioButtonLabel: constVarianteKeyAenderung, AbschnittTitel: constVarianteKeyAenderung },
  { Key: constVarianteKeyAbmeldung, RadioButtonLabel: constVarianteKeyAbmeldung, AbschnittTitel: constVarianteKeyAbmeldung }
];  

export const numericFieldsSN: string[] = [
  "Leistungsbedarf",
  "Leistung",
  "AbzumeldendeLeistung"
];

export const FormFieldsSN: IFormField[] = [
  {
    Id:    "Spannungsebene",
    Label:     "Spannungsebene",
    FieldType: constFTypeDropdown,
    required:  true
  },
  { 
    Id:    "Leistungsbedarf",                      
    Label:     "Leistungsbedarf",
    FieldType: constFTypeTextField,
    required:  true,
    used:      commonCode.VarianteIsErstAnforderung
  },
  { 
    Id:    "LageBeschreibung",                   
    Label:     "Beschreibung der gewünschten Lage des Übergabepunktes",
    FieldType: constFTypeTextField,
    ErrPrefix: "Beschreibung der gewünschten Lage des Übergabepunktes (Schalträume)",    //?
    required:  true,
    used:      commonCode.VarianteIsErstAnforderung
  },
  { 
    Id:    "Leistungsaenderung",                    
    Label:     "Leistungsänderung", 
    FieldType: constFTypeDropdown, 
    required:  true,
    used:      commonCode.VarianteIsAenderung
  },
  { 
    Id:    "Leistung",                   
    Label:     "Leistung",
    FieldType: constFTypeTextField,
    required:  true,
    used:      commonCode.VarianteIsAenderung
  },
  { 
    Id:    "AbzumeldendeLeistung",                   
    Label:     "Abzumeldende Leistung",
    FieldType: constFTypeTextField,
    required:  true,
    used:      commonCode.VarianteIsAbmeldung
  },
  {         // Exists also is RohrgefuehrteMedien, but with different Label
    Id:    "BemerkungAntragsteller",                   
    Label:     "Bemerkung Antragsteller",
    FieldType: constFTypeTextField,
    required:  false,
  },
];

